<script>
import LaptopPickButtons from './LaptopPickButtons'
import { actions } from '@utils'

export default {
  components: {
    LaptopPickButtons,
  },
  data() {
    return {
      countToPick: 6,
    }
  },
  methods: {
    clearLaptops() {
      this.setArticleLaptops([])
    },
    async pickLaptops({ countMain, countAlternatives }) {
      this.clearLaptops()

      const filtersMinimalScores = Object.fromEntries(Object
        .entries(this.criteria.minimalScores || {})
        .map(([key, value]) => [key, { $gte: value }]))

      const articleLaptops = await this.FIND_PRODUCT_PICK({
        articleId: this.article.id,
        activeLaptopIds: this.mainLaptopIdsSelected,
        criteria: {
          ...this.criteria,
          filters: filtersMinimalScores,
        },
        count: countMain,
        countAlternatives,
      })

      this.setArticleLaptops(articleLaptops)
    },
    ...actions('FIND_PRODUCT_PICK'),
  },

  watch: {
    'laptopBuckets.length'(laptopBucketsLength) {
      if (laptopBucketsLength <= this.countToPick) return

      this.countToPick = laptopBucketsLength
    },
  },

  render: () => '',
}
</script>
